<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		id: string;
		value?: string;
		ariaLabel: string;
		disabled?: boolean;
		placeholder?: string | null;
		label?: string;
		maxlength?: number;
		class?: ClassValue;
	}

	let {
		id,
		value = $bindable(''),
		ariaLabel,
		disabled = false,
		placeholder = null,
		label = '',
		maxlength = undefined,
		class: classes,
	}: Props = $props();

	let input: HTMLTextAreaElement;

	let active = $state(false);

	function onblur() {
		if (active) {
			active = false;
		}
	}

	function onfocus() {
		if (!active) {
			active = true;
		}
	}

	const activeClasses = $derived(active ? 'shadow-focus border-focus border-1' : 'hover:shadow-subtle');
	const dynamicClasses = $derived(disabled
		? 'bg-neutral-soft text-neutral '
		: `bg-neutral-weakest text-coloredneutral ${activeClasses}`);
</script>

<label for={id} class="text-sm">
	{label}

	<textarea
		{id}
		class={['textarea p-2 w-full rd-2 b-solid b-0.5 border-coloredneutral-weakest text-md text-coloredneutral bg-transparent placeholder:text-neutral disabled:text-neutral', {
			'shadow-focus': active,
			'mt-1': !!label,
			disabled,
		}, dynamicClasses, classes]}
		{placeholder}
		aria-label={ariaLabel}
		{disabled}
		{maxlength}
		bind:this={input}
		{onfocus}
		{onblur}
		bind:value
	></textarea>
</label>

<style>
	.textarea.disabled {
		pointer-events: none;
		cursor: default;
		user-select: none;
	}

	.textarea:focus-visible {
		outline: none;
	}
</style>
